const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://jseppud6yj.execute-api.us-west-2.amazonaws.com/prod',
    TEAM_API_URL: 'https://jmqtc4tpt8.execute-api.us-west-2.amazonaws.com/api'
  },
  reactApp: {
    VERSION: 'bugfix/CV4-3138-hotfix-teams-self-referencing-parents-children',
    HOSTNAME: 'https://teams-service.staging.saas.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.saas.forwoodsafety.com',
    WEBSOCKET: 'wss://8hbdhbgchl.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;
